import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type CardStyle = {
  isSmallMode?: boolean;
  noBorder?: boolean;
  showOverflow?: boolean;
};

export const cardStyles = ({ isSmallMode, noBorder, showOverflow }: CardStyle) => css`
  border-radius: ${theme.borderRadius.medium};
  border: ${noBorder ? '0px' : '1px'} solid ${theme.colors.neutral20};
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${theme.spacing(2)};
  overflow: ${showOverflow ? 'visible' : 'hidden'};
  padding: ${noBorder ? 0 : theme.spacing(isSmallMode ? 2 : 3)};
  position: relative;

  &.click-enabled {
    cursor: pointer;

    :hover {
      background-color: ${theme.colors.neutral5};
    }
  }
`;

export const chartWrapperStyles = css`
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

export const centerPosition = css`
  align-items: center;
  display: flex;
  flex-direction: column;
`;
